import React from "react";
import "./index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/site/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import WorkWithMe from "./pages/WorkWithMe";
import FollowTheCash from "./pages/FollowTheCash";
import MoneyFlowSession from "./pages/MoneyFlowSession";
import Advisory from "./pages/Advisory";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/legal/PrivacyPolicy";
import CookiePolicy from "./pages/legal/CookiePolicy";
import TermsOfUse from "./pages/legal/TermsOfUse";
import TermsAndConditions from "./pages/legal/TermsAndConditions";

function NotFound() {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center px-5 text-center" data-testid="not-found-page">
      <h1 className="font-display text-7xl">404</h1>
      <p className="mt-4 text-lg text-brand-stone">This page is somewhere in the financial fog.</p>
      <a href="/" className="btn-yellow mt-8">Back to home</a>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/work-with-me" element={<WorkWithMe />} />
          <Route path="/follow-the-cash" element={<FollowTheCash />} />
          <Route path="/money-flow-session" element={<MoneyFlowSession />} />
          <Route path="/advisory" element={<Advisory />} />
          {/* Legacy redirects */}
          <Route path="/services" element={<Navigate to="/work-with-me" replace />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
